<div class="vtr-ui-circle-radio-with-checkbox col-aut0 px-0 {{group}}"
	id="ui-circle-radio-with-checkbox"
	attr.aria-labelledby="{{textId}}-{{value}}-label"
	#radioButton
	role="radio"
	[tabIndex]="disabled ?-1:checked? 0 :-1"
	[attr.aria-disabled]="disabled"
	[attr.aria-checked]="checked"
	attr.aria-labelledby="{{textId}}-{{value}}-label"
	(keydown)="navigateByKeys($event,radio)"
	[ngClass]="{'white-theme': theme === 'white','blue-theme': theme === 'blue'}">
	<div class="checkbox">
		<input class="checkbox-custom"
			style="display: none;"
			attr.aria-labelledby="{{textId}}-{{value}}-label"
			[attr.aria-disabled]="disabled"
			[attr.aria-checked]="checked"
			[attr.aria-label]="label"
			id="{{radioId}}"
			name="{{group}}"
			type="radio"
			[value]="value"
			[checked]="checked"
			[disabled]="disabled"
			#radio
			(change)="onChange($event)"
			tabindex="-1">
		<label for="{{radioId}}"
			class="checkbox-custom-label"
			[style.cursor]="disabled?'default': 'pointer'"
			id="{{radioId}}-label"
			role="text"
			attr.aria-label="{{radioId}}">
			<div *ngIf="!hideIcon"
				[style.cursor]="disabled?'default': 'pointer'"
				[ngClass]="'icomoon icomoon-'+getIconName(value)"></div>
			<div *ngIf="customIcon && customIcon.length>0"
				[style.cursor]="disabled?'default': 'pointer'"
				[ngClass]="'icomoon icomoon-'+customIcon"></div>
			<fa-layers [fixedWidth]="true"
				*ngIf="checked"
				[style.cursor]="disabled?'default': 'pointer'">
				<fa-icon class="icon-circle"
					[class.icon-circle-disabled]="disabled"
					[icon]="['fas', 'circle']"></fa-icon>
				<fa-icon class="check-circle"
					[class.check-circle-disabled]="disabled"
					[icon]="['far', 'check-circle']"></fa-icon>
			</fa-layers>

		</label>
		<div [ngClass]="['title','text-center']"
			[class.disabled-title]="disabled"
			id="{{textId}}-{{value}}-label"
			role="text"
			attr.aria-label="{{label}}"
			[attr.aria-disabled]="disabled"
			[attr.aria-checked]="checked">{{processLabel ? (label | capitalizeFirst) : label}}</div>
	</div>
</div>
